import classNames from 'classnames';
import React, {ReactElement} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Spinner from 'ui-library/Spinner';

interface BaseLoadingScreenProps {
  className?: string;
}

function BaseLoadingScreen({className}: BaseLoadingScreenProps): JSX.Element {
  return (
    <div
      className={classNames('loading-spinner-background fullscreen-msg', className)}
      {...getTestProps({component: 'LoadingFullScreen', element: 'root'})}
    >
      <div className="loading-text">Loading...</div>
      <Spinner />
    </div>
  );
}

export function LoadingFileScreen(): ReactElement {
  return <BaseLoadingScreen className="loading-file-screen" />;
}

export default function LoadingFullScreen(): ReactElement {
  return <BaseLoadingScreen />;
}
